import { j as r } from "./jsx-runtime-CZlWR0BA.js";
import { H as a } from "./styled-components.browser.esm-CdvvWRMU.js";
const n = a.div`
  position: absolute;
  margin-top: 0;
  font-size: ${(e) => e.theme.fontSizeQuarck};
  line-height: ${(e) => e.theme.lineHeightTight};
  top: calc(100% - ${(e) => e.theme.spacingStackNano});
  padding: 0 ${(e) => e.theme.spacingInlineQuarckRem};
  color: ${({ isValid: e, isInvalid: o, theme: t }) => e ? t.colorSupportPositiveMedium : o ? t.colorSupportNegativeMedium : t.colorDisabledDark};
`, l = ({ children: e, isInvalid: o, isValid: t, ...i }) => /* @__PURE__ */ r.jsx(n, { isInvalid: o, isValid: t, role: "alert", "aria-live": "polite", ...i, children: e }), c = l;
export {
  c as H
};
